import api from '../config/api';

// Cart API Service
const cartAPI = {
  // Get current user's cart
  getCart: async (addressId = null) => {
    try {
      const url = addressId ? `/cart?addressId=${addressId}` : '/cart';
      const res = await api.get(url);
      return res.data;
    } catch (error) {
      console.error('Error fetching cart:', error);
      throw error;
    }
  },

  // Add item to cart
  addToCart: async (restaurantId, productId, quantity = 1, variationId = null, addOnsIds = [], clearCart = false) => {
    try {
      const res = await api.post('/cart/item', {
        restaurantId,
        productId,
        quantity,
        variationId,
        addOnsIds,
        clearCart
      });
      return res.data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  },

  // Merge guest cart with backend
  mergeCart: async (items) => {
    try {
      const res = await api.post('/cart/merge', { items });
      return res.data;
    } catch (error) {
      console.error('Error merging cart:', error);
      throw error;
    }
  },

  // Remove item from cart
  removeItem: async (itemId) => {
    try {
      const res = await api.delete(`/cart/item/${itemId}`);
      return res.data;
    } catch (error) {
      console.error('Error removing from cart:', error);
      throw error;
    }
  },

  // Update item quantity
  updateQuantity: async (itemId, quantity) => {
    try {
      const res = await api.patch(`/cart/item/${itemId}/quantity`, {
        quantity
      });
      return res.data;
    } catch (error) {
      console.error('Error updating quantity:', error);
      throw error;
    }
  },

  // Update cart meta (address, notes, etc)
  updateMeta: async (meta) => {
    try {
      const res = await api.put('/cart/meta', meta);
      return res.data;
    } catch (error) {
      console.error('Error updating cart meta:', error);
      throw error;
    }
  },

  // Validate coupon code
  validateCoupon: async (couponCode) => {
    try {
      const res = await api.post('/cart/validate-coupon', {
        couponCode
      });
      return res.data;
    } catch (error) {
      console.error('Error validating coupon:', error);
      throw error;
    }
  },

  // Get all public active promocodes
  getPublicCoupons: async () => {
    try {
      const res = await api.get('/cms/promocodes');
      return res.data;
    } catch (error) {
      console.error('Error fetching public coupons:', error);
      throw error;
    }
  }
};

export default cartAPI;
